import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../images/Coloured.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createUserWithEmailAndPassword,
  getAdditionalUserInfo,
  sendEmailVerification,
} from "firebase/auth";
import { CircularProgress } from "@mui/material";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";
import PasswordStrengthBar from "react-password-strength-bar";
import { setNewUser } from "../../redux/actions/authActions";
import { partialUpdateUser } from "../../services/UserService";
import { loginWithGoogle, signup } from "../../services/AuthService";

const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [Loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [emailVal, setEmailVal] = useState(false);
  const [passwordVal, setPasswordVal] = useState(false);
  const [passwordLengthVal, setPasswordLengthVal] = useState(false);
  const [userNameVal, setUserNameVal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const provider = new GoogleAuthProvider();
  const auth = getAuth();
  const [params] = useSearchParams();
  const [samePassword, setSamePassword] = useState(false);
  const { isNewUser } = useSelector((state) => state.authReducer);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [checkboxVal, setCheckboxVal] = useState(false);

  useEffect(() => {
    if (params.get("emailId")) {
      setEmail(params.get("emailId"));
    }
  }, []);

  useEffect(() => {
    const keyDownHandler = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSignUp();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [email, password, userName]);

  const handleSignUp = () => {
    signInUser();
  };

  const addUserToFirebase = async (user) => {
    const settings = {
      payment: {
        language: "English", // Default language
        subscription: "Free", // Default subscription
      },
      feature: "", // Default feature
      timeLimit: 2,
    };
    const newUserDocData = {
      name: userName,
      email: email,
      createdAt: new Date(),
      // appSettings: settings,
    };

    partialUpdateUser(user.uid, newUserDocData,
        (response) => {
          // Send email verification
          sendEmailVerification(auth.currentUser).then(() => {
            toast.success("Verification email sent. Please verify to login.");
          });

          // Dispatch the action to set isNewUser to true
          // dispatch(setAppSettings(settings));
          dispatch(setNewUser(true));

          // Navigate to the login page
          navigate("/login");
        },
        (error) => {
          console.error("Error adding user to Firestore: ", error);
          toast.error("Error creating user. Please try again later.");
        }
    )
  };

  const signInUser = () => {
    setLoading(true);
    signup(email, password, userName,
      {
        toast,
        isCheckboxChecked,
        setLoading,
        setEmailVal,
        setUserNameVal,
        setPasswordVal,
        setCheckboxVal,
        setSamePassword,
        setPasswordLengthVal,
        dispatch,
        navigate,
        setNewUser
      }
    )
  };

  return (
    // <div className='md:w-[35%] sm:w-[70%] w-[80%]'>
    <div className="xl:w-[35%] mx-auto  md:w-[50%] w-[80%] sm:w-[60%]">
      <div className="pb-[15px]">
        <img
          src={logo}
          className="xl:w-[300px] md:w-[250px] w-[200px] mx-auto"
          alt=""
        />
      </div>
      <div className=" border-[2px] border-[white] py-[20px] rounded-[10px] shadow">
        <div className="mx-[10%]">
          <div className="md:text-xl text-lg text-center">
            Take the first step in joining the one true productivity revolution!
          </div>
          <button
            onClick={() => {
              if(!isCheckboxChecked){
                setCheckboxVal(true);
              }else{
                loginWithGoogle({
                  auth, provider, dispatch, setNewUser, navigate
                })
              }
            }}
            className="border w-full flex hover:scale-105 hover:shadow-md transition items-center justify-center gap-[10px] sm:gap-[20px] text-black py-[10px] text-lg rounded-md my-[15px]"
          >
            <FcGoogle className="text-2xl" /> Sign up with Google
          </button>
          <div className="text-center text-gray-400">OR</div>
          <input
            type="text"
            placeholder="Full name"
            value={userName}
            onChange={(e) => {
              setUserName(e.target.value);
              setUserNameVal(false);
            }}
            className="outline-0 pb-[5px] border-b-[2px] border-[#577D86]  w-[100%] mt-[10px] md:text-[16px] text-[14px]"
          />
          {userNameVal && <div className="wrong">Please enter name</div>}
          <input
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailVal(false);
            }}
            type="email"
            placeholder="Email "
            className="outline-0 pb-[5px] border-b-[2px] border-[#577D86] md:text-[16px] text-[14px] w-[100%] mt-[10px]"
          />
          {emailVal && <div className="wrong">Please enter email</div>}
          <div className="flex justify-between relative items-center w-[100%] mt-[10px]">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordVal(false);
                setPasswordLengthVal(false);
              }}
              className="pb-[5px] w-[80%] outline-0 md:text-[16px] text-[14px]"
            />
            <label
              className="relative right-[20px]"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <AiOutlineEyeInvisible className="md:h-[18px] h-[15px] md:w-[18px] w-[15px]" />
              ) : (
                <AiOutlineEye className="md:h-[18px] h-[15px] md:w-[18px] w-[15px]" />
              )}
            </label>
          </div>
          <PasswordStrengthBar
            password={password}
            onChangeScore={(score, feedback) => {
              console.log({ score, feedback });
            }}
          />
          {passwordVal && <div className="wrong">Please enter password</div>}
          {password.length < 6 && passwordLengthVal && (
            <div className="wrong">
              Password should be atleast 6 characters long
            </div>
          )}
          {samePassword && (
            <div className="wrong">
              Username and password should not be same
            </div>
          )}
          <button
            onClick={handleSignUp}
            className="w-[100%] bg-[#576CBC] text-[white] py-[2%] rounded-[5px] md:text-[18px] text-[15px] text-center cursor-pointer my-[10px]"
          >
            {Loading ? <CircularProgress color="inherit" /> : "Sign up"}
          </button>
          <div className="mb-2">
            {checkboxVal && (
              <div className="wrong">Please tick the check box</div>
            )}
            <div class="flex items-center ">
              <input
                id="link-checkbox"
                type="checkbox"
                value=""
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                onChange={(e) => setIsCheckboxChecked(e.target.checked)}
              />

              <label
                for="link-checkbox"
                class="ml-2 text-sm font-medium text-black dark:text-gray-300"
              >
                I agree with the{" "}
                <a
                  href="https://www.meetminutes.in/terms"
                  class=" text-blue-600 dark:text-blue-500 hover:underline"
                >
                  Terms Of Use
                </a>{" "}
                and{" "}
                <a
                  href="https://www.meetminutes.in/privacy-policy"
                  class="text-blue-600 dark:text-blue-500 hover:underline"
                >
                  Privacy Policy.
                </a>
              </label>
            </div>
          </div>
          <div className="text-center md:text-[16px] text-[14px] text-[#577D86]">
            Already have an account?{" "}
            <button
              onClick={() => {
                navigate("/login");
              }}
              className=" text-[#576CBC] md:text-[16px] text-[14px] underline"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
